import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const Container = styled.div`
  max-width: 560px;
  display: flex;
  @media (max-width: 769px) {
    flex-direction: column;
  }
`;

export const IconWrap = styled.div`
  position: absolute;
  top: 40px;
  right: 40px;
  cursor: pointer;
  @media (max-width: 769px) {
    top: 16px;
    right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    svg {
      fill: ${colors.WHITE};
    }
  }
`;

export const Content = styled.div`
  padding: 30px 70px;

  button {
    width: 100%;
    margin-top: 40px;
  }

  @media (max-width: 769px) {
    padding: 24px 24px 32px;
  }
`;

export const Title = styled.div`
  font-size: 30px;
  line-height: 34px;
  font-family: ${fonts.rubikMedium};
  letter-spacing: -0.2px;
  span {
    color: ${colors.MAIN_ORANGE};
  }
  @media (max-width: 769px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const Text = styled.div`
  font-style: normal;
  font-size: 18px;
  line-height: 28px;
  font-family: ${fonts.rubikRegular};
  margin-top: 32px;
  color: #686868;
  @media (max-width: 769px) {
    margin-top: 16px;
  }
`;

export const InputWrap = styled.div`
  margin-top: 40px;
  @media (max-width: 769px) {
    margin-top: 24px;
  }
`;

export const ButtonJoinWaitlist = styled.button`
  height: 48px;
  width: 100%;
  margin-top: 24px;
  font-family: ${fonts.rubikMedium};
  font-size: 14px;
  line-height: 16px;
  background: ${colors.MAIN_ORANGE};
  color: ${colors.WHITE};
  border: 0;
  border-radius: 12px;
  cursor: pointer;
`;

export const ImagesContainer = styled.div`
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 30px;
    gap: 16px;
  }
`;

export const AppStoreImage = styled.img`
  max-width: 140px;
  max-height: 40px;
  cursor: pointer;
`;

export const QRcontainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 5px;
  width: 237px;

  img {
    max-width: 72px;
    max-height: 72px;
    margin-right: 16px;
  }

  p {
    font-family: ${fonts.rubikRegular};
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #686868;
    width: 107px;
  }
`;
